import React, { useState, useEffect } from "react";
import DashBoardSidebar from "../../layouts/dashBoard-Sidebar";
import DashboardNavbar from "../../layouts/dashboardNavbar";
import { toast } from "react-toastify";
import { getPendingInvoiceHistory, updateAttorneyInvoice } from "../../api/server";
import PaginatedItems from "./pagination";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import { FaEye } from "react-icons/fa";
import BillingSourceTabs from "./BillingSourceTabs";
import BillingFilterDropdown from "./BillingFilterDropdown";
import "./BillingWorkspace.css";

const AttorneyInvoiceHistory = () => {
    const [response, setResponse] = useState([]);
    const [getLoading, setGetLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [toBeUpdatedIds, setToBeUpdatedIds] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [courseValue, setCourseValue] = useState('all');
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [filterValue, setFilterValue] = useState('unpaid');


    const fetchData = async (course, page, searchTerm = '',status) => {
        // const cacheKey = `${course}_${page}_${searchTerm}`;
        setIsSearchActive(!!searchTerm);
          setGetLoading(true);
            try {
                const res = await getPendingInvoiceHistory(page, course, searchTerm,status ? status : "unpaid" );
                const newData = res.data.data;
                const newTotal = res.data.total;

                // setPageCache(prevCache => ({
                //     ...prevCache,
                //     [cacheKey]: {
                //         cachedResponse: newData,
                //         cachedTotal: newTotal,
                //     },
                // }));

                setResponse(newData);
                setTotal(newTotal);
            } catch (err) {
                toast.error(err.response?.data?.error || "Failed to fetch data");
            } finally {
                setGetLoading(false);
            }








        // if (!forceRefresh && pageCache[cacheKey]) {
        //     const { cachedResponse, cachedTotal } = pageCache[cacheKey];
        //     setResponse(cachedResponse);
        //     setTotal(cachedTotal);
        // } else {
        //     setGetLoading(true);
        //     try {
        //         const res = await getPendingInvoiceHistory(page, course, searchTerm,status ? status : "unpaid" );
        //         const newData = res.data.data;
        //         const newTotal = res.data.total;

        //         setPageCache(prevCache => ({
        //             ...prevCache,
        //             [cacheKey]: {
        //                 cachedResponse: newData,
        //                 cachedTotal: newTotal,
        //             },
        //         }));

        //         setResponse(newData);
        //         setTotal(newTotal);
        //     } catch (err) {
        //         toast.error(err.response?.data?.error || "Failed to fetch data");
        //     } finally {
        //         setGetLoading(false);
        //     }
        // }
    };

const handlePageChange = (newpage) => {
    setPageNo(newpage)
        fetchData(courseValue,newpage ? newpage : pageNo, search, filterValue );
 
}
    const handleUpdateBilling = () => {
        setUpdateLoading(true)
        updateAttorneyInvoice({ ids: toBeUpdatedIds })
            .then(res => {
                if (res?.data?.success) {
                    // Remove updated IDs from cache


                    fetchData(courseValue, pageNo, search, filterValue);
                    toast.success(res.data.message);
                    setToBeUpdatedIds([]);
                } else {
                    toast.error(res.data.message);
                }
        setUpdateLoading(false)

            })
            .catch(err => {
                toast.error(err?.response?.data?.message || "Update failed");
                setUpdateLoading(false);
            });
    };


    // useEffect(() => {
    //     fetchData(courseValue, pageNo, search);
    // }, [courseValue, pageNo]);

    useEffect(() => {
        fetchData(courseValue, pageNo, search,filterValue);
    }, []);

    useEffect(() => {
        setToBeUpdatedIds([]);
    }, [pageNo,filterValue,courseValue]);


    const handleChange = (e, billing) => {
        console.log("asdfnamsdf")
        const id = billing.id;
        setToBeUpdatedIds(prev =>
            e.target.checked ? [id, ...prev] : prev.filter(item => item !== id)
        );
    };

    const handleChangeCourse = (newCourse) => {
        setCourseValue(newCourse);
        setPageNo(1); // Reset to first page
        fetchData(newCourse, 1, search,filterValue);
    };

      const handleChangefilter = (newFilter) => {
        setFilterValue(newFilter);
        setPageNo(1); // Reset to first page
        fetchData(courseValue, 1, search,newFilter);
    };



    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            setPageNo(1);
            fetchData(courseValue, 1, search,filterValue);
        }
    };

    return (
        <div>
            <div className="wrapper">
                <DashBoardSidebar />
                <div id="content">
                    <DashboardNavbar />
                    <section className="manage-students language_wrap billing-workspace">
                        <BillingSourceTabs activeSource="attorney" view="history" />
                        <div className="invoice-history-toolbar">
                            <div className="invoice-history-controls">
                              <BillingFilterDropdown
                                id="attorney-history-course-filter"
                                label="Course"
                                icon="fa-solid fa-graduation-cap"
                                value={courseValue}
                                onChange={handleChangeCourse}
                                options={[
                                  { value: "all", label: "All" },
                                  { value: "first", label: "CC" },
                                  { value: "second", label: "DE" },
                                ]}
                              />
                              <BillingFilterDropdown
                                id="attorney-history-status-filter"
                                label="Payment Status"
                                icon="fa-solid fa-circle-check"
                                value={filterValue}
                                onChange={handleChangefilter}
                                options={[
                                  { value: "unpaid", label: "Not paid" },
                                  { value: "paid", label: "Paid" },
                                ]}
                              />
                            <div className="invoice-history-search billing-filter-field">
                                <label htmlFor="attorney-invoice-search">
                                  <i className="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
                                  Search Attorney
                                </label>
                                <div className="invoice-history-search-control">
                                <input
                                    id="attorney-invoice-search"
                                    className="form-control"
                                    type="text"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    onKeyDown={handleSearchKeyDown}
                                    placeholder="Search"
                                />
                                <button
                                    type="button"
                                    aria-label="Search attorney invoices"
                                    onClick={() => fetchData(courseValue, 1, search,filterValue)} 
                                ><i className="fa fa-search" aria-hidden="true"></i></button>
                                </div>
                            </div>

                            {
                                isSearchActive &&
                                <button
                                    className="invoice-history-reset"
                                    onClick={() => {
                                        setSearch('');
                                        setPageNo(1);
                                        fetchData(courseValue, 1, '',filterValue);
                                    }}>
                                    Reset
                                </button>
                            }
                            </div>
                        </div>



                        {/* <button
                          className="btn_brnd mt-3 me-3 flex"
                          onClick={handleClearFilters}
                        >
                          Clear Search
                        </button> */}
                        <div className="billing-list-card">
                            <div className="billing-list-table-scroll">
                                <table className="table glade-billing-table billing-list-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Attorney Name</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Invoice</th>
                                            <th scope="col">Created At</th>
                                            <th scope="col">paid</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getLoading ? (
                                            <tr>
                                                <td colSpan={5}>
                                                    <ThreeDots
                                                        height="40"
                                                        width="80"
                                                        radius="9"
                                                        color="#4fa94d"
                                                        ariaLabel="three-dots-loading"
                                                        wrapperStyle={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                        wrapperClassName="spinner"
                                                        visible={true}
                                                    />
                                                </td>
                                            </tr>
                                        ) : response && response.length > 0 ? (
                                            response.map((billing, index) => (
                                                <tr key={index}>
                                                    {/* <th scope="row">
                                                        <Link
                                                            to={`/editstudent?id=${billing?.id}`}
                                                            style={{
                                                                color: "#000",
                                                            }}
                                                        >
                                                            {billing?.name}
                                                        </Link>
                                                    </th> */}
                                                     <td style={{
                                                                    color: "#000",
                                                                }}>{billing?.name}</td>

                                                    <td>{billing?.amount}</td>
                                                    <td>
                                                        <a href={billing.link} target="_blank" rel="noreferrer">
                                                            <FaEye style={{ cursor: 'pointer', color: 'black' }} />
                                                        </a>
                                                    </td>
                                                    <td>{moment(billing?.created_at).format("MMMM Do YYYY")}</td>
                                                    <td>
                                                        <div className="iagree_radio">
                                                            <input
                                                                type="checkbox"
                                                                name="tickbox"
                                                                id={`check${index}`}
                                                                className=" "
                                                                checked={
                                                                    toBeUpdatedIds.includes(billing.id) || billing.paid === "checked"
                                                                        ? true
                                                                        : false
                                                                }
                                                                onChange={(e) => {
                                                                    handleChange(e, billing);
                                                                }}
                                                                disabled={billing.paid === "checked" ? true : false}
                                                            />
                                                            <label
                                                                htmlFor={`check${index}`}
                                                                className="text-white"
                                                            >
                                                                B
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5}>No pending Billing found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                { response && response.length > 0 && (
                                    <div className="text-center">
                                        <button
                                            className="btn_brnd mt-4 me-3"
                                            disabled={updateLoading || toBeUpdatedIds.length === 0 || filterValue === "paid"}
                                            onClick={handleUpdateBilling}
                                        >
                                            {updateLoading ? (
                                                <ThreeDots
                                                    height="20"
                                                    width="60"
                                                    radius="9"
                                                    color="#4fa94d"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{
                                                        display: "block",
                                                    }}
                                                    wrapperClassName="spinner"
                                                    visible={true}
                                                />
                                            ) : (
                                                "Update"
                                            )}
                                        </button>
                                    </div>
                                )}

                                {!getLoading && total !== 0 && total > 10 && (
                                    <PaginatedItems
                                        pageSize={10}
                                        total={total}
                                        pageNo={pageNo}
                                        setPageNo={setPageNo}
                                        handlePageChange={handlePageChange}
                                    />
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default AttorneyInvoiceHistory;
